/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide1description1Inputs */

const he_extension_slide1description1 = /** @type {(inputs: Extension_Slide1description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפו בגרפים מפורטים של היסטוריית מחירים ישירות בדפי המוצרים`)
};

const en_extension_slide1description1 = /** @type {(inputs: Extension_Slide1description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View detailed price history charts directly on product pages`)
};

/**
* | output |
* | --- |
* | "View detailed price history charts directly on product pages" |
*
* @param {Extension_Slide1description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide1description1 = /** @type {((inputs?: Extension_Slide1description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide1description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide1description1(inputs)
	return en_extension_slide1description1(inputs)
});
export { extension_slide1description1 as "extension_slide1Description" }